module.exports = __webpack_public_path__ + "static/img/11.857c695.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/11.png
// module id = k93K
// module chunks = 0